import { MessageCircle, Instagram, Mail, MapPin, Clock } from "lucide-react";
import { school, whatsappLink } from "@/data/content";

export default function Footer() {
  return (
    <footer className="relative bg-ink text-white pt-20 pb-10">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid md:grid-cols-3 gap-12 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img src={school.logo} alt="Recriar" className="h-16 w-16 object-contain bg-white rounded-2xl p-1" />
              <span className="font-display font-600 text-xl leading-tight">Instituto<br />Educacional Recriar</span>
            </div>
            <p className="font-body text-white/70 leading-relaxed max-w-xs">
              Família e escola caminham juntas na construção de uma infância acolhedora, segura e cheia de aprendizados.
            </p>
          </div>

          <div>
            <h4 className="font-display font-600 text-lg mb-5 text-brand-yellow">Contato</h4>
            <ul className="space-y-4 font-body text-white/80">
              <li className="flex items-start gap-3"><MapPin className="h-5 w-5 text-brand-sky shrink-0 mt-0.5" /> {school.address}</li>
              <li className="flex items-start gap-3"><Clock className="h-5 w-5 text-brand-sky shrink-0 mt-0.5" /> {school.hours}</li>
              <li className="flex items-start gap-3"><Mail className="h-5 w-5 text-brand-sky shrink-0 mt-0.5" /> <a href={`mailto:${school.email}`} className="hover:text-white break-all">{school.email}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-600 text-lg mb-5 text-brand-yellow">Fale com a gente</h4>
            <div className="flex flex-col gap-3">
              <a href={whatsappLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="inline-flex items-center gap-2 rounded-full bg-brand-green px-5 py-3 font-700 hover:-translate-y-0.5 transition-transform duration-300 w-fit">
                <MessageCircle className="h-5 w-5" /> {school.whatsappDisplay}
              </a>
              <a href={school.instagramUrl} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-2 rounded-full bg-white/10 px-5 py-3 font-700 hover:bg-white/20 transition-colors duration-300 w-fit">
                <Instagram className="h-5 w-5" /> @{school.instagram}
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-white/50 text-sm">© {new Date().getFullYear()} Instituto Educacional Recriar · Desde {school.founded}</p>
          <p className="font-body text-white/40 text-sm">Feito com carinho para as nossas crianças.</p>
        </div>
      </div>
    </footer>
  );
}
